module.exports = __webpack_public_path__ + "static/img/coupons_transfer.f0a99f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupons_transfer.png
// module id = RgpV
// module chunks = 1